import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { CaretLeft, CaretRight } from '@phosphor-icons/react'

const images = Array.from({ length: 13 }, (_, i) => `/images/auth/slider/${i + 1}.jpg`)

const AuthCarousel = () => {
  const { t } = useTranslation(['auth'])
  const SLIDE_WIDTH_WITH_GAP = window.innerWidth >= 768 ? 520 : 270
  const [currentSlide, setCurrentSlide] = React.useState(0)
  const [startPosition, setStartPosition] = React.useState(null)
  const [isDragging, setIsDragging] = React.useState(false)
  const trackRef = React.useRef(null)

  const onPrev = () => {
    setCurrentSlide((prev) => {
      if (prev === 0) {
        return prev
      }
      return prev - 1
    })
  }

  const onNext = () => {
    setCurrentSlide((prev) => {
      if (prev === images.length - 1) {
        return 0
      }
      return prev + 1
    })
  }

  useEffect(() => {
    const interval = setInterval(() => {
      onNext()
    }, 5000)

    return () => clearInterval(interval)
  }, [currentSlide])

  const handleTouchStart = (e) => {
    setStartPosition(e.touches[0].clientX)
    setIsDragging(true)
  }

  const handleTouchMove = (e) => {
    if (!isDragging || startPosition === null) return

    const currentPosition = e.touches[0].clientX
    const delta = currentPosition - startPosition
    trackRef.current.style.transform = `translateX(calc(-${
      currentSlide * SLIDE_WIDTH_WITH_GAP
    }px + ${delta}px))`
  }

  const handleTouchEnd = (e) => {
    if (!isDragging || startPosition === null) return

    const endPosition = e.changedTouches[0].clientX
    const delta = endPosition - startPosition

    if (delta > 50 && currentSlide > 0) {
      onPrev()
    } else if (delta < -50 && currentSlide < images.length - 1) {
      onNext()
    } else {
      // Note: transform track to default slide position
      trackRef.current.style.transform = `translateX(-${currentSlide * SLIDE_WIDTH_WITH_GAP}px)`
    }

    setStartPosition(null)
    setIsDragging(false)
  }

  return (
    <div className="auth__carousel">
      <div className="auth__carousel__nav">
        <header>
          <p>{t('auth:authCarousel.subtitle')}</p>
          <h1>{t('auth:authCarousel.title')}</h1>
        </header>
        <div className="auth__carousel__nav__control auth__carousel__nav__control_desktop">
          <button onClick={onPrev}>
            <CaretLeft size={16} />
          </button>
          <button onClick={onNext}>
            <CaretRight size={16} />
          </button>
        </div>
      </div>
      <div className="auth__carousel__slider">
        <div
          className="auth__carousel__slider__track"
          ref={trackRef}
          style={{
            transform: `translateX(-${currentSlide * SLIDE_WIDTH_WITH_GAP}px)`,
          }}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {images.map((image) => (
            <img src={image} key={image} className="slide" />
          ))}
        </div>
      </div>
      <div className="auth__carousel__nav__control auth__carousel__nav__control_mobile">
        <button onClick={onPrev}>
          <CaretLeft size={16} />
        </button>
        <button onClick={onNext}>
          <CaretRight size={16} />
        </button>
      </div>
    </div>
  )
}

export default AuthCarousel
